// Autogenerated. Do not alter manually. Script: "outdated_browser"

var OutdatedBrowser = require('/Users/dusan/dev/spinview/web-scripts/src/outdated_browser/outdated_browser.js');

(function (container) {

	container.SPINVIEW_OPTIONS = container.SPINVIEW_OPTIONS || {};

	// Create "OutdatedBrowser"
	if (container.outdatedBrowser) {
		throw new Error('Service "outdatedBrowser" already exists in the container. Check your script tags!');
	}
	container.OutdatedBrowser_options = assign({}, container.SPINVIEW_OPTIONS.OutdatedBrowser);
	container.outdatedBrowser = new OutdatedBrowser(OutdatedBrowser_options, container);

	initialize([
		container.outdatedBrowser.init,
	]);

	function assign(source, target) {
		if (!target) {
			return source;
		}
		
		for (var key in target) {
			if (target.hasOwnProperty && target.hasOwnProperty(key) && target[key] !== undefined) {
				source[key] = target[key];
			}
		}
		return source;
	}


	function initialize(fns) {
		var index = 0;
		next();
		
		function next() {
			if (index >= fns.length) {
				return;
			}
			if (fns[index].length > 0) {
				fns[index](callback);
			} else {
				fns[index]();
				callback();
			}
		}
		
		function callback(err) {
			if (err) {
				if (!err._logged) {
					console.error(err);
				}
			}
			index++;
			next();
		}
	}

})(window);
